import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      // `block` não é enfeite: `<label>` é inline por padrão, e caixa inline
      // IGNORA margem vertical. O `space-y-*` do Tailwind 4 aplica
      // `margin-bottom` no filho que não é o último — com o rótulo inline,
      // aqueles pixels existiam no CSS computado e não produziam espaço nenhum
      // na tela.
      //
      // 15px fixo contra os 16px do campo: a pergunta um degrau abaixo da
      // resposta. O `text-sm` fluido daqui resolvia para os mesmos 16px do
      // valor, e a hierarquia sumia.
      'block text-[0.9375rem] font-medium leading-none text-foreground',
      'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
